import { edisonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function EdisonPage() {
  return <CityPageTemplate config={edisonConfig} />;
}